import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { Button, ButtonProps } from 'components';
import styles from './SubmitButton.module.scss';

type SubmitButtonProps = {
    isSubmitting?: boolean,
    label: string,
    submittingLabel: string
} & ButtonProps;

const SubmitButton = ({ disabled, isSubmitting, label, submittingLabel, ...rest }: SubmitButtonProps) => (
    <Button 
        disabled={disabled || isSubmitting} 
        className={disabled ? styles.submitButtonDisabled : styles.submitButtonSubmitting}
        tabIndex={0}
        {...rest}>
            {isSubmitting ? (
                <>
                    <FontAwesomeIcon icon={faSpinner} className={`${styles.spinner} fa-spin`} />
                    {submittingLabel}
                </>
            ) : label}
    </Button>
);

export default SubmitButton;